import { jsx as y } from "react/jsx-runtime";
import { c as a } from "../index-BNmRGtA6.js";
import { c as r } from "../clsx-OuTLNxxd.js";
import '../Card.css';const g = "320px", m = "600px", h = "1025px", f = "_card_1idqk_32", _ = "_primary_1idqk_46", p = "_secondary_1idqk_50", b = "_shouldCenter_1idqk_78", e = {
  mobile: g,
  "mobile-wide": "480px",
  tablet: m,
  "tablet-wide": "800px",
  desktop: h,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  card: f,
  primary: _,
  secondary: p,
  "padding-s": "_padding-s_1idqk_54",
  "padding-m": "_padding-m_1idqk_58",
  "padding-l": "_padding-l_1idqk_62",
  "borderRadius-s": "_borderRadius-s_1idqk_66",
  "borderRadius-m": "_borderRadius-m_1idqk_70",
  "borderRadius-l": "_borderRadius-l_1idqk_74",
  shouldCenter: b
}, H = a(e.card, {
  variants: {
    variant: {
      primary: e.primary,
      secondary: e.secondary
    }
  },
  defaultVariants: {
    variant: "primary"
  }
}), W = ({
  borderRadius: t = "m",
  children: n,
  className: o,
  height: x,
  padding: i,
  shouldCenter: s,
  variant: c,
  ...d
}) => {
  const l = x ? { "--cxy-card-height": x } : {};
  return /* @__PURE__ */ y(
    "div",
    {
      className: r(
        H({ variant: c }),
        {
          [e[`padding-${i}`]]: i && typeof i == "string",
          [e.shouldCenter]: s,
          [e[`borderRadius-${t}`]]: t
        },
        o
      ),
      style: l,
      ...d,
      children: n
    }
  );
};
export {
  W as Card
};
